module.exports = __webpack_public_path__ + "img/08.4704c32e.png";